// Улицы
import autoText from './components/street';

export const AT_TYPE = 'street';

export default autoText;
